import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import MaterialsListView from "./materials-list.html";
import MaterialsEditView from "./materials-edit.html";


angular.module("materials", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('materials', {
                url: "/materials",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('materials.list', {
                url: "/list",
                controller: "MaterialsListCtrl",
                template: MaterialsListView,
                cache: false,
                data: { pageTitle: 'Materiales' },
                requiredPermission: ["MATERIAL_READ"]
            })            
            .state('materials.edit', {
                url: "/edit/:id&:is_external",
                controller: "MaterialsEditCtrl",
                cache: false,
                template: MaterialsEditView,
                data: { pageTitle: 'Materiales' },
                requiredPermission: ["MATERIAL_READ"]
            })
    }])
;